const UserData = [
    { 
      name: "Rahul",
      number : "8088678789",
      team: "Support",
      role: "admin",
      status: "Active",
      action:'Enabled'
      
    },
    {
      
        name: "Ramya",
        number : "9876567483",
        team: "Sales",
        role: "admin",
        status: "Inactive",
        action:'Disabled'
    },
    {
        name: "Sumanth",
        number : "9481315868",
        team: "Engineering",
        role: "admin",
        status: "Active",
        action:'Enabled'
    },
    
  ];
  
  export default UserData;
  